import React, { FC, useCallback, useState } from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { Button } from '@chakra-ui/react';

import { MasterOutlet } from '@app/api/models';
import { RequestPayload } from '@app/api/types';
import { useApi, useFetchData } from '@app/hooks';
import { QueryTable } from '@app/components/common/table';
import { usePermissions } from '@app/hooks/use-permissions';
import { ROLES } from '@app/navigation/types';

import { useColumns } from './hooks/use-columns';
import { OutletDrawer } from './modals/drawer';
import { FilterPanel } from './components/filter-panel';

const OutletsTable: FC = () => {
  const api = useApi();
  const history = useHistory();
  const [selectedOutlet, setSelectedOutlet] = useState<MasterOutlet | undefined>();

  const canEdit = usePermissions({ roles: [ROLES.ADMIN, ROLES.CHIEF] });

  const getMasterOutlets = useCallback(
    (payload: RequestPayload) =>
      api.acb.getMasterOutlets(payload),
    [api]
  );

  const columns = useColumns({ canEdit });
  const [fetchData] = useFetchData<MasterOutlet>({ method: getMasterOutlets });

  const onRowClick = useCallback((outlet: MasterOutlet) => {
    setSelectedOutlet(outlet);
  } , []);

  const onEditClick = useCallback(() => {
    if (!canEdit || !selectedOutlet) {return;}
    history.push(`/acl/outlets/${selectedOutlet.id}/`, {
      masterOutlet: selectedOutlet,
    });
  }, [canEdit, history, selectedOutlet]);

  return (
    <>
      <QueryTable<MasterOutlet>
        title="Торговые точки"
        additionalToolbar={<Button as={Link} to="/acl/outlets/grid/" size="sm" variant="outline">Табличное редактирование</Button>}
        columns={columns}
        fetchData={fetchData}
        canDownload={canEdit}
        onRowClick={onRowClick}
        secondaryToolbar={<FilterPanel />}
      />
      <OutletDrawer open={!!selectedOutlet} canEdit={canEdit} onClose={() => setSelectedOutlet(undefined)} outlet={selectedOutlet} onEditClick={onEditClick} />
    </>
  );
};

export default OutletsTable;
